import React, { useEffect } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { projectAddEdit } from "../../../../services/projectService";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Checkbox from "../../../form/Checkbox";
import DatePicker from "../../../form/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const validation = {
  title: { required: true, message: "Title is required" },
};

const ManageProject = ({ getResponse = () => {}, close = () => {}, data }) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: { status: true, featured: true },
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        image: data?.image?.url,
        status: data?.status === 1 ? true : false,
        onGoing: data?.deadline ? false : true,
      });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const { onGoing, deadline, ...rest } = val;
      return await projectAddEdit({
        ...rest,
        status: val?.status ? 1 : 2,
        featured: val?.featured,
        ...(data?._id && { id: data?._id }),
        deadline: onGoing ? null : deadline,
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-12">
          <Input
            label={"Project Title"}
            inputPlaceholder={"Enter Project Title"}
            inputName="title"
            value={values?.title || ""}
            onChange={handleChange}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-12">
          <Input
            label={"Donation Link"}
            inputPlaceholder={"Enter Donation Link"}
            inputName="donationLink"
            value={values?.donationLink || ""}
            onChange={handleChange}
            {...formValidate(errors, "donationLink")}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label={"Goal Amount"}
            inputPlaceholder={"Enter Goal Amount"}
            inputName="goalAmount"
            // inputType={"number"}
            value={values?.goalAmount || ""}
            onChange={handleChange}
            {...formValidate(errors, "goalAmount")}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label={"Current Amount Raised"}
            inputPlaceholder={"EnterCurrent Amount Raised"}
            inputName="raisedAmount"
            // inputType={"number"}
            value={values?.raisedAmount || ""}
            onChange={handleChange}
            {...formValidate(errors, "raisedAmount")}
          />
        </div>
        <div className="relative col-span-6">
          <DatePicker
            label={"Fundraising start"}
            placeholder="Fundraising start"
            value={{
              startDate: values?.startDate,
              endDate: values?.startDate,
            }}
            onChange={(e) => {
              const end = new Date(values?.deadline);

              const start = new Date(e?.startDate);
              if (values?.deadline) {
                if (start > end) {
                  handleChange({
                    target: {
                      value: null,
                      name: "startDate",
                    },
                  });
                  toast.info("Open date must be smaller then close date");
                } else {
                  handleChange({
                    target: {
                      value: dayjs(e?.startDate).format(
                        "YYYY-MM-DDT00:00:00.000[Z]"
                      ),
                      name: "startDate",
                    },
                  });
                }
              } else {
                handleChange({
                  target: {
                    value: dayjs(e?.startDate).format(
                      "YYYY-MM-DDT00:00:00.000[Z]"
                    ),
                    name: "startDate",
                  },
                });
              }
              // handleChange({
              //   target: {
              //     value: dayjs(e?.startDate).format(
              //       "YYYY-MM-DDT00:00:00.000[Z]"
              //     ),
              //     name: "startDate",
              //   },
              // });
            }}
            {...formValidate(errors, "startDate")}
          />
        </div>
        <div className="relative col-span-6 flex items-center">
          <div className="flex items-center">
            <Checkbox
              checkboxLabel={"Onging Project"}
              checkboxLableClass={"font-bold !text-sm text-secondayColor"}
              checkboxName={"onGoing"}
              checked={values?.onGoing || ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="relative col-span-6">
          <DatePicker
            label={"Fundraising Deadline"}
            placeholder="Fundraising Deadline"
            value={{
              startDate: values?.deadline,
              endDate: values?.deadline,
            }}
            onChange={(e) => {
              const start = new Date(values?.startDate);
              const end = new Date(e?.startDate);

              if (values?.startDate) {
                if (start > end) {
                  handleChange({
                    target: {
                      value: null,
                      name: "deadline",
                    },
                  });
                  toast.info("Close date must be smaller then open date");
                } else {
                  handleChange({
                    target: {
                      value: dayjs(e?.startDate).format(
                        "YYYY-MM-DDT00:00:00.000[Z]"
                      ),
                      name: "deadline",
                    },
                  });
                }
              }
              // handleChange({
              //   target: {
              //     value: dayjs(e?.startDate).format(
              //       "YYYY-MM-DDT00:00:00.000[Z]"
              //     ),
              //     name: "deadline",
              //   },
              // });
            }}
            {...formValidate(errors, "deadline")}
            isDisabled={values.onGoing}
          />
        </div>
        {/* <div className="relative col-span-6">
          <Select
            label={"Category"}
            placeholder="Category"
            selectedValue={values?.categoryId}
            dropdownData={
              [
                // { name: "Active", value: 1 },
                // { name: "InActive", value: 2 },
              ]
            }
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "categoryId", value: val },
              });
            }}
          />
        </div> */}
        <div className="relative col-span-6">
          <FileUploadSingle
            size="small"
            label={"Upload Project Image"}
            value={values?.image}
            onChange={(file) =>
              handleChange({ target: { name: "image", value: file } })
            }
            {...formValidate(errors, "image")}
          />
        </div>
        <div className="relative col-span-12">
          <Editor
            label="Project Description"
            placeholder="Description"
            value={values?.description}
            onChange={(val) =>
              handleChange({ target: { name: "description", value: val } })
            }
            {...formValidate(errors, "description")}
          />
        </div>

        <div className="relative col-span-6 space-y-2">
          <div className="font-bold text-base">Publish Status</div>
          <div className="flex items-center">
            <Checkbox
              checkboxLabel={"Publish this project"}
              checkboxLableClass={"font-bold !text-sm text-secondayColor"}
              checkboxName={"status"}
              checked={values?.status || ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="relative col-span-6 space-y-2">
          <div className="font-bold text-base">Feature on Homepage</div>
          <div className="flex items-center">
            <Checkbox
              checkboxLabel={"Feature this project on the homepage"}
              checkboxLableClass={"font-bold !text-sm text-secondayColor"}
              checkboxName={"featured"}
              checked={values?.featured || ""}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageProject;
